<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/business']">Sociedades</a></li>
    <!--<li *ngIf="view"><a [routerLink]="['/configuration/business']">{{view.getEntityBaseName(true)}}</a></li>-->
</ul>

<app-view #view [code]="'business.list'" [model]="businessFilters" (onEvent)="onEvent($event)"></app-view>
